export interface PaketObatConfig {
  title: string;
  noDataText: string;
  itemsTitle: string;
  confirmText: string;
}

export const PAKET_OBAT: Record<string, PaketObatConfig> = {
  curetage: {
    title: "Lembar Permintaan Obat Paket Curetage",
    noDataText: "Belum ada permintaan obat paket curetage",
    itemsTitle: "Daftar Obat & Alkes Paket Curetage",
    confirmText: "Apakah Anda yakin ingin menghapus permintaan obat paket curetage ini?",
  },
  sc: {
    title: "Permintaan Obat Paket Sectio Caesaria (SC)",
    noDataText: "Belum ada permintaan obat paket SC",
    itemsTitle: "Daftar Obat & Alkes Paket Sectio Caesaria (SC)",
    confirmText: "Apakah Anda yakin ingin menghapus permintaan obat paket SC ini?",
  },
  partus_pervaginam: {
    title: "Permintaan Obat Paket Partus Pervaginam",
    noDataText: "Belum ada permintaan obat paket partus pervaginam",
    itemsTitle: "Daftar Obat & Alkes Paket Partus Pervaginam",
    confirmText: "Apakah Anda yakin ingin menghapus permintaan obat paket partus pervaginam ini?",
  },
  laparotomi: {
    title: "Permintaan Obat Paket Ops Laparotomi",
    noDataText: "Belum ada permintaan obat paket laparotomi",
    itemsTitle: "Daftar Obat & Alkes Paket Ops Laparotomi",
    confirmText: "Apakah Anda yakin ingin menghapus permintaan obat paket laparotomi ini?",
  },
};
